export default ['1.35',

  '1.33',

  '1.33'];
